export default "__VITE_ASSET__DF06rpJx__"